import { render, staticRenderFns } from "./lni-retaliation-contact.component.vue?vue&type=template&id=998af2f6"
import script from "./lni-retaliation-contact.component.vue?vue&type=script&lang=js"
export * from "./lni-retaliation-contact.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports